import { combineReducers } from 'redux';
import { messageReducer } from './message.reducer';
import { categoryReducer } from './category.reducer';
import { brandReducer } from './brand.reducer';
import { bookmarkReducer } from './bookmark.reducer';
import { followReducer } from './follow.reducer';

const allReducers = combineReducers({
	messageReducer,
	categoryReducer,
	brandReducer,
	bookmarks: bookmarkReducer,
	follows: followReducer,
});

export default allReducers;
